var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8443 0.99504L13.7065 10.99H11.1205L13.2586 0.99504H15.8443ZM26.723 7.4489L28.0839 3.6956L28.8672 7.4489H26.723ZM29.609 10.99H32L29.9111 0.99504H27.7056C27.2086 0.99504 26.7895 1.28324 26.6041 1.72767L22.7242 10.99H25.4398L25.9789 9.49731H29.2959L29.609 10.99ZM22.8588 7.72698C22.8701 5.08915 19.2123 4.94303 19.2368 3.76439C19.2447 3.40627 19.5864 3.02478 20.3332 2.92722C20.7034 2.87956 21.7252 2.8409 22.8833 3.37458L23.3363 1.25424C22.7143 1.02921 21.9138 0.8125 20.9177 0.8125C18.3614 0.8125 16.5632 2.17031 16.5489 4.1162C16.5324 5.55517 17.8334 6.35749 18.8115 6.83677C19.82 7.32661 20.1578 7.64066 20.1529 8.07835C20.1459 8.74894 19.3488 9.0459 18.6065 9.05714C17.3058 9.07738 16.5518 8.70555 15.9509 8.42545L15.4815 10.6166C16.0867 10.8936 17.2017 11.1345 18.3563 11.1469C21.0739 11.1469 22.8508 9.80506 22.8588 7.72698ZM12.1495 0.99504L7.95982 10.99H5.22689L3.165 3.01332C3.04001 2.5228 2.93098 2.34251 2.55084 2.13524C1.92903 1.79759 0.902583 1.48174 0 1.28526L0.0611471 0.99504H4.46099C5.02142 0.99504 5.52565 1.36799 5.65402 2.01362L6.74318 7.7978L9.43295 0.99504H12.1495Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.64d6649c42b7412b5e112f8ce95b8076.svg";
export { ForwardRef as ReactComponent };